import { useRef } from "react";
import {
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import RichTextEditorDialog from "../prize-draw-admin/RichTextEditor";


export default function GameProviderMultilingualInputs({
    gameProvider,
    languageKey,
    languageName,
    onChange
}) {
    const editorRef = useRef();

    if (!gameProvider || !languageKey || !languageName) {
        return null;
    }

    // Generic handler for all field changes
    const handleFieldChange = (fieldName, value) => {
        const updatedGameProvider = {
            ...gameProvider,
            [fieldName]: {
                ...gameProvider[fieldName],
                [languageKey]: value
            }
        };
        onChange && onChange(updatedGameProvider);
    };

    // With card wrapper
    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField
                    label={`Name (${languageName})`}
                    fullWidth
                    value={gameProvider.nameI18n?.[languageKey] || ""}
                    variant="outlined"
                    onChange={(e) => handleFieldChange('nameI18n', e.target.value)}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={`Transaction Name (${languageName})`}
                    fullWidth
                    value={gameProvider.transactionNameI18n?.[languageKey] || ""}
                    variant="outlined"
                    onChange={(e) => handleFieldChange('transactionNameI18n', e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                    Description ({languageName})
                </Typography>
                <RichTextEditorDialog
                    editorRef={editorRef}
                    value={gameProvider.descriptionI18n?.[languageKey] || ""}
                    onChange={(html) => handleFieldChange('descriptionI18n', html)}
                    fieldName={`description_${languageKey}`}
                />
            </Grid>
        </Grid>

    );
}
